import { useEffect, useState } from "react";
import { isBiddingClosed } from "../utils/biddingTime";

type BiddingOrder = { state?: string | null; closesAt?: string | null } | null | undefined;

/**
 * Whether the RFQ has closed, flipping by itself at the closing instant so a
 * page left open stops offering to quote without a reload.
 */
export const useBiddingClosed = (order: BiddingOrder): boolean => {
  const [now, setNow] = useState(() => new Date());
  const closesAt = order?.closesAt;

  useEffect(() => {
    if (!closesAt) return;
    const wait = new Date(closesAt).getTime() - Date.now();
    if (wait <= 0) return;
    // setTimeout caps at ~24.8 days; a later closing is re-armed on the next render.
    const timer = setTimeout(() => setNow(new Date()), Math.min(wait + 500, 2_000_000_000));
    return () => clearTimeout(timer);
  }, [closesAt, now]);

  return isBiddingClosed(order, now);
};
